import * as i0 from '@angular/core';
import { Directive, Input, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

var Color;
(function (Color) {
    Color["Primary"] = "primary";
    Color["Basic"] = "basic";
    Color["Accent"] = "accent";
    Color["Warn"] = "warn";
})(Color || (Color = {}));

class FsSelectButtonDirective {
    constructor(renderer, hostElement) {
        this.renderer = renderer;
        this.hostElement = hostElement;
        this.buttonType = 'raised';
        this.width = '';
        this._color = Color.Basic;
        this._colorType = null;
    }
    set color(value) {
        if (!value) {
            return;
        }
        this._clearColor();
        this._color = value;
        if (value.match(/^#/)) {
            this.renderer.setStyle(this.hostElement.nativeElement, 'background-color', value);
            this._colorType = "style" /* Style */;
        }
        else {
            this.renderer.addClass(this.hostElement.nativeElement, 'mat-' + value);
            this._colorType = "klass" /* Klass */;
        }
    }
    set setWidth(width) {
        this.width = width;
    }
    ;
    ngOnInit() {
        const buttonType = this.buttonType === 'basic' ? 'mat-button' : `mat-${this.buttonType}-button`;
        this.renderer.addClass(this.hostElement.nativeElement, buttonType);
        this.renderer.addClass(this.hostElement.nativeElement, 'fs-select-button');
        this._textColorUpdate();
    }
    ngOnChanges(changes) {
        if (changes.color && changes.color.currentValue !== changes.color.previousValue) {
            this._textColorUpdate();
        }
    }
    _clearColor() {
        if (this._colorType === "klass" /* Klass */) {
            this.renderer.removeClass(this.hostElement.nativeElement, 'mat-' + this._color);
        }
        else if (this._colorType === "style" /* Style */) {
            this.renderer.removeStyle(this.hostElement.nativeElement, 'background-color');
        }
        this._color = null;
        this._colorType = null;
    }
    _textColorUpdate() {
        const value = this.hostElement.nativeElement.querySelector('.mat-select-trigger .mat-select-value');
        const arrow = this.hostElement.nativeElement.querySelector('.mat-select-arrow-wrapper .mat-select-arrow');
        let textColor = null;
        switch (this._color) {
            case Color.Basic:
                textColor = 'initial';
                break;
            default:
                textColor = '#fff';
        }
        this.renderer.setStyle(value, 'color', textColor);
        this.renderer.setStyle(arrow, 'color', textColor);
    }
}
FsSelectButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsSelectButtonDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
FsSelectButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FsSelectButtonDirective, selector: "[fsSelectButton]", inputs: { color: "color", setWidth: ["width", "setWidth"], buttonType: "buttonType" }, host: { properties: { "style.max-width": "this.width" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsSelectButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsSelectButton]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { color: [{
                type: Input
            }], setWidth: [{
                type: Input,
                args: ['width']
            }], buttonType: [{
                type: Input
            }], width: [{
                type: HostBinding,
                args: ['style.max-width']
            }] } });

class FsSelectButtonModule {
}
FsSelectButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsSelectButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsSelectButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsSelectButtonModule, declarations: [FsSelectButtonDirective], imports: [CommonModule,
        MatSelectModule,
        FormsModule], exports: [FsSelectButtonDirective] });
FsSelectButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsSelectButtonModule, imports: [[
            CommonModule,
            MatSelectModule,
            FormsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FsSelectButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatSelectModule,
                        FormsModule
                    ],
                    exports: [
                        FsSelectButtonDirective
                    ],
                    declarations: [
                        FsSelectButtonDirective
                    ]
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Color, FsSelectButtonDirective, FsSelectButtonModule };
